import Features from "../uidispatcherapi/Features";
import { FeatureSessionStore } from "../uidispatcherapi/FeatureSessionStore";

export function useTouchScreenUI(): boolean {
    return FeatureSessionStore.getMembershipFor(Features.TOUCH_SCREEN_UI) === "B";
}
